module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.msal.isAuthenticated) ? _c('div', {
    attrs: {
      "id": "authPage"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    attrs: {
      "src": "/static/img/logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center col-sm-12"
  }, [_c('h1', [_vm._v("Authentification")]), _vm._v(" "), _c('h4', [_vm._v("Veuillez vous connecter.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.$msal.signIn()
      }
    }
  }, [_vm._v("Connexion")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-229d2162"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AuthPage.vue
// module id = 1336
// module chunks = 1